import { Component } from '@theme/component';
class RumeCombinedOptions extends Component {
  #controller;
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const signal = this.#controller.signal;
    this.addEventListener('click', this.#choose, { signal });
    this.addEventListener('keydown', this.#key, { signal });
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#controller?.abort(); }
  #choose = (event) => {
    const button = event.target.closest('button[data-part]');
    if (!button || !this.contains(button)) return;
    const metal = button.dataset.part === 'metal' ? button.dataset.value : this.dataset.selectedMetal;
    const stone = button.dataset.part === 'stone' ? button.dataset.value : this.dataset.selectedStone;
    const picker = this.closest('variant-picker');
    const radio = [...(picker?.querySelectorAll('.rume-combined-source input') || [])].find(input => input.value === `${metal} / ${stone}`);
    if (!radio) return;
    this.dataset.selectedMetal = metal;
    this.dataset.selectedStone = stone;
    for (const sibling of this.querySelectorAll('button[data-part]')) {
      const selected = sibling.dataset.value === (sibling.dataset.part === 'metal' ? metal : stone);
      sibling.setAttribute('aria-checked', String(selected));
      sibling.tabIndex = selected ? 0 : -1;
    }
    radio.click();
  };
  #key = (event) => {
    if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
    const current = event.target.closest('button[data-part]');
    if (!current) return;
    event.preventDefault();
    const buttons = [...current.closest('fieldset').querySelectorAll('button')];
    const index = buttons.indexOf(current);
    const step = ['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1;
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + step + buttons.length) % buttons.length;
    buttons[next].focus();
    buttons[next].click();
  };
}
if (!customElements.get('rume-combined-options')) customElements.define('rume-combined-options', RumeCombinedOptions);
